import CreateIRmcModule from "./create";
import ViewIRmcModule from "./view";
import ViewIRmcQusetions from "./questions";
export const IrmcModule = {
  createIrmc: CreateIRmcModule,
  viewIrmc: ViewIRmcModule,
  IrmsQuestions: ViewIRmcQusetions,
};
